import React from 'react';
import { Attachments } from 'components';
import { useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';
import { MicroserviceTypes } from 'typings';
import { useLeadByIdQuery } from 'api';

export const LeadAttachments = React.memo(() => {
  const { id } = useParams() as { id: string };
  const { hasAccess } = useAccessControl();
  const { data: { isFinalStatus } = {} } = useLeadByIdQuery({ id }, { skip: !id });
  return (
    <Attachments
      entityId={id}
      entityName={'LEAD'}
      service={'wrd' as MicroserviceTypes}
      hasAccessToWrite={hasAccess(PERMISSIONS.leads.attachment.write) && !isFinalStatus}
      hasAccessToDelete={hasAccess(PERMISSIONS.leads.attachment.delete) && !isFinalStatus}
    />
  );
});
